package com.trevorwiebe.timesheet.di

import com.trevorwiebe.timesheet.settlements.data.SettlementRepositoryImpl
import com.trevorwiebe.timesheet.settlements.domain.SettlementRepository
import com.trevorwiebe.timesheet.settlements.presentation.SettlementsViewModel
import com.trevorwiebe.timesheet.invoicing.presentation.InvoicingViewModel
import com.trevorwiebe.timesheet.invoicing.domain.InvoiceRepository
import com.trevorwiebe.timesheet.invoicing.data.InvoiceRepositoryImpl
import com.trevorwiebe.timesheet.calendar.data.CalendarRepositoryImpl
import com.trevorwiebe.timesheet.calendar.domain.CalendarRepository
import com.trevorwiebe.timesheet.mileage.data.LocationRepositoryImpl
import com.trevorwiebe.timesheet.mileage.data.MileageRepositoryImpl
import com.trevorwiebe.timesheet.mileage.data.EquipmentRepositoryImpl
import com.trevorwiebe.timesheet.mileage.domain.LocationRepository
import com.trevorwiebe.timesheet.mileage.domain.MileageRepository
import com.trevorwiebe.timesheet.mileage.domain.EquipmentRepository
import com.trevorwiebe.timesheet.mileage.domain.usecases.AddMileageEntry
import com.trevorwiebe.timesheet.mileage.domain.usecases.DeleteMileageEntry
import com.trevorwiebe.timesheet.mileage.domain.usecases.UpdateMileageEntry
import com.trevorwiebe.timesheet.mileage.presentation.MileageViewModel
import com.trevorwiebe.timesheet.calendar.domain.usecases.DeleteTimeOffRequest
import com.trevorwiebe.timesheet.calendar.domain.usecases.GetTimeOffRequests
import com.trevorwiebe.timesheet.calendar.domain.usecases.PostTimeOffRequest
import com.trevorwiebe.timesheet.calendar.domain.usecases.ReviewTimeOffRequest
import com.trevorwiebe.timesheet.calendar.presentation.CalendarViewModel
import com.trevorwiebe.timesheet.core.data.CoreRepositoryImpl
import com.trevorwiebe.timesheet.core.data.GeocodingRepositoryImpl
import com.trevorwiebe.timesheet.core.data.HttpInterfaceImpl
import com.trevorwiebe.timesheet.core.data.ImageExtractionService
import com.trevorwiebe.timesheet.mileage.data.ReceiptExtractionService
import com.trevorwiebe.timesheet.loads.data.LoadFileStorageRepository
import com.trevorwiebe.timesheet.mileage.data.ReceiptStorageRepository
import com.trevorwiebe.timesheet.core.domain.CoreRepository
import com.trevorwiebe.timesheet.core.domain.GeocodingRepository
import com.trevorwiebe.timesheet.core.domain.HttpInterface
import com.trevorwiebe.timesheet.core.domain.usecases.GetCurrentPayPeriodStartAndEnd
import com.trevorwiebe.timesheet.core.presentation.AppViewModel
import com.trevorwiebe.timesheet.admin.carrier.data.CarrierRepositoryImpl
import com.trevorwiebe.timesheet.admin.carrier.domain.CarrierRepository
import com.trevorwiebe.timesheet.admin.carrier.presentation.CarriersViewModel
import com.trevorwiebe.timesheet.admin.customer.data.CustomerRepositoryImpl
import com.trevorwiebe.timesheet.admin.customer.domain.CustomerRepository
import com.trevorwiebe.timesheet.admin.customer.presentation.CustomersViewModel
import com.trevorwiebe.timesheet.admin.equipment.presentation.EquipmentViewModel
import com.trevorwiebe.timesheet.admin.locations.presentation.LocationsViewModel
import com.trevorwiebe.timesheet.admin.organization.presentation.OrganizationViewModel
import com.trevorwiebe.timesheet.admin.ownerOperator.data.OwnerOperatorRepositoryImpl
import com.trevorwiebe.timesheet.admin.ownerOperator.domain.OwnerOperatorRepository
import com.trevorwiebe.timesheet.admin.ownerOperator.presentation.OwnerOperatorsViewModel
import com.trevorwiebe.timesheet.admin.loadrate.data.LoadRateRepositoryImpl
import com.trevorwiebe.timesheet.admin.loadrate.domain.LoadRateRepository
import com.trevorwiebe.timesheet.admin.loadrate.presentation.LoadRateViewModel
import com.trevorwiebe.timesheet.admin.rate.data.RateRepositoryImpl
import com.trevorwiebe.timesheet.admin.rate.domain.RateRepository
import com.trevorwiebe.timesheet.admin.rate.presentation.RateViewModel
import com.trevorwiebe.timesheet.admin.employeeHours.domain.usecases.AddUpHoursWithOvertime
import com.trevorwiebe.timesheet.admin.employeeHours.domain.usecases.GetEmployeeHoursReport
import com.trevorwiebe.timesheet.admin.employeeHours.presentation.EmployeeHoursViewModel
import com.trevorwiebe.timesheet.admin.reporting.presentation.ReportingViewModel
import com.trevorwiebe.timesheet.admin.usermanagement.data.UserManagementRepositoryImpl
import com.trevorwiebe.timesheet.admin.usermanagement.domain.UserManagementRepository
import com.trevorwiebe.timesheet.admin.usermanagement.presentation.UserManagementViewModel
import com.trevorwiebe.timesheet.loads.data.LoadsRepositoryImpl
import com.trevorwiebe.timesheet.loads.domain.LoadsRepository
import com.trevorwiebe.timesheet.loads.domain.usecases.AddLoad
import com.trevorwiebe.timesheet.loads.domain.usecases.DeleteLoad
import com.trevorwiebe.timesheet.loads.domain.usecases.MoveLoad
import com.trevorwiebe.timesheet.loads.domain.usecases.UpdateLoad
import com.trevorwiebe.timesheet.loads.domain.usecases.UpdateLoadAssignment
import com.trevorwiebe.timesheet.loads.presentation.LoadsViewModel
import com.trevorwiebe.timesheet.more.presentation.MoreViewModel
import com.trevorwiebe.timesheet.punch.data.PunchRepositoryImpl
import com.trevorwiebe.timesheet.punch.domain.PunchRepository
import com.trevorwiebe.timesheet.punch.domain.usecases.AddUpHours
import com.trevorwiebe.timesheet.punch.domain.usecases.CalculateTimeSheets
import com.trevorwiebe.timesheet.punch.domain.usecases.ProcessPunchesForUi
import com.trevorwiebe.timesheet.punch.presentation.PunchViewModel
import com.trevorwiebe.timesheet.payPeriod.data.PayPeriodRepositoryImpl
import com.trevorwiebe.timesheet.payPeriod.domain.PayPeriodRepository
import com.trevorwiebe.timesheet.payPeriod.presentation.PayPeriodViewModel
import com.trevorwiebe.timesheet.signin.data.AuthImpl
import com.trevorwiebe.timesheet.signin.domain.Authenticator
import com.trevorwiebe.timesheet.signin.presentation.auth.SignInViewModel
import dev.gitlive.firebase.Firebase
import io.ktor.client.HttpClient
import org.koin.core.module.Module
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

interface FirebaseEmulatorConfig {
    fun setupEmulators(firebase: Firebase)
}

expect fun createEmulatorConfig(): FirebaseEmulatorConfig

expect fun clearFirestoreCache(firebase: Firebase)

expect fun httpClient(): HttpClient

object Debug {
    var isDebug: Boolean = false
}

expect val platformModule: Module

val sharedModule = module {
    single<Firebase>(createdAtStart = true) {
        val firebase = Firebase
        if (Debug.isDebug) {
            val emulatorConfig = createEmulatorConfig()
            emulatorConfig.setupEmulators(firebase)
        }
        clearFirestoreCache(firebase)
        firebase
    }
    single<HttpInterface> { HttpInterfaceImpl(httpClient()) }
    single<GeocodingRepository> { GeocodingRepositoryImpl(httpClient(), get()) }
    single<CoreRepository> { CoreRepositoryImpl(get(), get()) }
    single<Authenticator> { AuthImpl(get(), get()) }
    single<PunchRepository> { PunchRepositoryImpl(get(), get()) }
    single<PayPeriodRepository> { PayPeriodRepositoryImpl(get(), get()) }
    single<CalendarRepository> { CalendarRepositoryImpl(get(), get()) }
    single<EquipmentRepository> { EquipmentRepositoryImpl(get(), get()) }
    single<RateRepository> { RateRepositoryImpl(get(), get()) }
    single<LoadRateRepository> { LoadRateRepositoryImpl(get(), get()) }
    single<LocationRepository> { LocationRepositoryImpl(get(), get()) }
    single<CustomerRepository> { CustomerRepositoryImpl(get(), get()) }
    single<CarrierRepository> { CarrierRepositoryImpl(get(), get()) }
    single<OwnerOperatorRepository> { OwnerOperatorRepositoryImpl(get(), get()) }
    single<MileageRepository> { MileageRepositoryImpl(get(), get()) }
    single<LoadsRepository> { LoadsRepositoryImpl(get(), get()) }
    single<InvoiceRepository> { InvoiceRepositoryImpl(get(), get()) }
    single<SettlementRepository> { SettlementRepositoryImpl(get(), get()) }
    single<UserManagementRepository> { UserManagementRepositoryImpl(get(), get()) }
    single { AddLoad(get(), get(), get()) }
    single { UpdateLoad(get(), get(), get()) }
    single { MoveLoad(get()) }
    single { UpdateLoadAssignment(get()) }
    single { DeleteLoad(get()) }
    single { AddMileageEntry(get(), get()) }
    single { UpdateMileageEntry(get(), get()) }
    single { DeleteMileageEntry(get()) }
    single { ImageExtractionService() }
    single { ReceiptExtractionService(get()) }
    single { ReceiptStorageRepository(httpClient()) }
    single { LoadFileStorageRepository() }

    single<GetCurrentPayPeriodStartAndEnd> { GetCurrentPayPeriodStartAndEnd() }
    single { AddUpHoursWithOvertime() }
    single { GetEmployeeHoursReport(get(), get(), get(), get(), get(), get()) }
    single<CalculateTimeSheets> { CalculateTimeSheets(get()) }
    single<ProcessPunchesForUi> { ProcessPunchesForUi() }
    single<AddUpHours> { AddUpHours() }
    single<PostTimeOffRequest> { PostTimeOffRequest(get()) }
    single<GetTimeOffRequests> { GetTimeOffRequests(get()) }
    single<DeleteTimeOffRequest> { DeleteTimeOffRequest(get()) }
    single<ReviewTimeOffRequest> { ReviewTimeOffRequest(get()) }
    viewModelOf(::AppViewModel)
    viewModelOf(::SignInViewModel)
    viewModelOf(::MoreViewModel)
    viewModelOf(::LoadsViewModel)
    viewModelOf(::EquipmentViewModel)
    viewModelOf(::RateViewModel)
    viewModelOf(::LoadRateViewModel)
    viewModelOf(::LocationsViewModel)
    viewModelOf(::CustomersViewModel)
    viewModelOf(::CarriersViewModel)
    viewModelOf(::OwnerOperatorsViewModel)
    viewModelOf(::ReportingViewModel)
    viewModelOf(::InvoicingViewModel)
    viewModelOf(::SettlementsViewModel)
    viewModelOf(::OrganizationViewModel)
    viewModelOf(::CalendarViewModel)
    viewModelOf(::MileageViewModel)
    viewModelOf(::UserManagementViewModel)
    viewModelOf(::EmployeeHoursViewModel)
    // PayPeriodViewModel takes an optional userId (null = current user; admin passes an
    // employee id to view that employee's pay periods), so it needs a parameterized factory.
    factory { (userId: String?) ->
        PayPeriodViewModel(
            payPeriodRepository = get(),
            coreRepository = get(),
            userId = userId,
        )
    }
    // PunchViewModel accepts navigation/admin parameters via a factory definition.
    factory { (startDate: String?, endDate: String?, timeSheetId: String?, userId: String?, isAdmin: Boolean) ->
        PunchViewModel(
            startDate = startDate,
            endDate = endDate,
            timeSheetId = timeSheetId,
            userId = userId,
            isAdmin = isAdmin,
            punchRepository = get(),
            coreRepository = get(),
            calculateTimeSheets = get(),
            processPunchesForUi = get(),
            addUpHours = get(),
            getCurrentPayPeriodStartAndEnd = get()
        )
    }
}